// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Check40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Check40: FC<Check40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m15.806 29.833-9.39-9.388 1.987-1.987 7.402 7.403L31.57 10.097l1.987 1.986-17.75 17.75Z" />
        </svg>
    );
};

export default Check40;
